import { formatDistanceToNow } from "date-fns";
import { getTimeZone } from "../stores/timeZone";
import { parseDate } from "./timeZone";

/** Formats an API timestamp in the selected timezone. */
export function formatDate(date, pattern, timeZone = getTimeZone()) {
  const parsed = parseDate(date).tz(timeZone);
  return parsed.isValid() ? parsed.format(pattern) : "-";
}

export function fDate(date) {
  return formatDate(date, "DD MMMM YYYY");
}

export function fDateTime(date) {
  return formatDate(date, "DD MMM YYYY HH:mm:ss");
}

export function fTimestamp(date) {
  return parseDate(date).valueOf();
}

export function fDateTimeSuffix(date, defaultValue = null) {
  return !date && defaultValue ? defaultValue : fDateTime(date);
}

export function fToNow(date) {
  const parsed = parseDate(date);
  return parsed.isValid() ? formatDistanceToNow(parsed.toDate(), { addSuffix: true }) : "-";
}
